import { BufferGeometry, Group, Material, Mesh, Object3D } from 'three';
import { isArray } from 'underscore';

/**
 * Recursively traverses the object and disposes andy buffer geometry or any materials it can find.
 */
export function disposeGeometriesAndMaterials(object?: Object3D | Group) {
  object?.traverse((node) => {
    const geometry = (node as Mesh).geometry;
    const material: Material[] | Material | undefined = (node as Mesh).material;

    if (geometry instanceof BufferGeometry) {
      geometry.dispose();
    }

    if (isArray(material)) {
      material.forEach((x) => x.dispose());
    } else {
      material?.dispose();
    }
  });
}
